// extracted by mini-css-extract-plugin
module.exports = {"notice":"KycReasonNotice_notice__Kykzi","center":"KycReasonNotice_center__9hqUl"};